import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    getSupportChatApi,
    getSupportChatMessagesApi,
    sendSupportMessageApi,
} from "./supportApi";

export const getSupportChats = createAsyncThunk(
    "chat/getSupportChats",
    async ({ page, limit }, thunkAPI) => {
        try {
            const res = await getSupportChatApi({ page, limit });
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const getSupportMessages = createAsyncThunk(
    "chat/getSupportMessages",
    async ({ chatId, page, limit }, thunkAPI) => {
        try {
            const res = await getSupportChatMessagesApi({
                chatId,
                page,
                limit,
            });
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const sendSupportMessage = createAsyncThunk(
    "chat/sendSupportMessage",
    async (data, thunkAPI) => {
        try {
            const res = await sendSupportMessageApi(data);
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

const chatSlice = createSlice({
    name: "chat",
    initialState: {
        chats: [],
        messages: [],
        selectedChatId: null,
        loading: false,
    },
    reducers: {
        setSelectedChat: (state, action) => {
            state.selectedChatId = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSupportChats.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSupportChats.fulfilled, (state, action) => {
                state.loading = false;
                state.chats = action.payload?.items || [];
            })
            .addCase(getSupportChats.rejected, (state) => {
                state.loading = false;
            })

            .addCase(getSupportMessages.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSupportMessages.fulfilled, (state, action) => {
                state.loading = false;
                state.messages = action.payload?.items || [];
            })
            .addCase(getSupportMessages.rejected, (state) => {
                state.loading = false;
            })

            .addCase(sendSupportMessage.fulfilled, (state, action) => {
                state.messages.push(action.payload?.data);
            });
    },
});

export const { setSelectedChat } = chatSlice.actions;
export default chatSlice.reducer;